/**
 * L1J Protocol Opcodes for L1J-JP 3.63C (Japanese client).
 * Mirrors l1j-gateway/src/main/java/l1j/gateway/crypto/Opcodes.java.
 */

// Client -> Server Opcodes
export const C_OPCODE = {
  BOOKMARK: 134,
  FIGHT: 47,
  KEEPALIVE: 182,
  ATTACK: 68,
  CHANGEHEADING: 65,
  PICKUPITEM: 188,
  SHOP: 16,
  DELETECHAR: 10,
  DELETEBUDDY: 211,
  LEAVEPARTY: 204,
  CHARACTERCONFIG: 129,
  MOVECHAR: 95,
  CHANGECHAR: 237,
  PRIVATESHOPLIST: 193,
  CHAT: 190,
  BOARDREAD: 59,
  TRADEADDITEM: 241,
  PROPOSE: 185,
  MAIL: 22,
  HIRESOLDIER: 97,
  BOARD: 73,
  LOGINTOSERVEROK: 75,
  ENTERPORTAL: 249,
  LEAVECLANE: 121,
  CALL: 144,
  TRADE: 103,
  SKILLBUYOK: 207,
  SHIP: 117,
  CLIENTVERSION: 127,
  EXTCOMMAND: 157,
  TRADEADDCANCEL: 167,
  SENDLOCATION: 41,
  MAPSYSTEM: 41,
  DRAWAL: 192,
  COMMONCLICK: 53,
  SELECTTARGET: 155,
  NEWCHAR: 253,
  FIX_WEAPON_LIST: 106,
  DROPITEM: 54,
  ADDBUDDY: 99,
  WHO: 49,
  BOARDDELETE: 12,
  TRADEADDOK: 110,
  CREATECLAN: 154,
  ATTR: 61,
  ARROWATTACK: 247,
  NPCACTION: 37,
  TITLE: 96,
  DEPOSIT: 35,
  DELETEINVENTORYITEM: 209,
  CHECKPK: 137,
  BANPARTY: 70,
  CLAN: 246,
  DOOR: 199,
  PLEDGE: 225,
  CREATEPARTY: 166,
  RANK: 88,
  TELEPORT: 242,
  CHARRESET: 236,
  PETMENU: 217,
  BOARDWRITE: 14,
  GIVEITEM: 244,
  LOGINTOSERVER: 131,
  CHATWHISPER: 122,
  SKILLBUY: 173,
  JOINCLAN: 30,
  RETURNTOLOGIN: 218,
  CHANGEWARTIME: 4,
  WAR: 235,
  BANCLAN: 222,
  RESULT: 40,
  BUDDYLIST: 60,
  TAXRATE: 200,
  USEPETITEM: 213,
  SELECTLIST: 238,
  LOGINPACKET: 57,
  QUITGAME: 104,
  CHATGLOBAL: 62,
  EXCLUDE: 101,
  NPCTALK: 58,
  USEITEM: 44,
  EMBLEM: 107,
  EXIT_GHOST: 210,
  AMOUNT: 109,
  FISHCLICK: 26,
  BOOKMARKDELETE: 223,
  USESKILL: 115,
  CAHTPARTY: 113,
} as const;

// Server -> Client Opcodes
export const S_OPCODE = {
  REMOVE_OBJECT: 185,
  CHARPACK: 3,
  INVLIST: 180,
  LOGINRESULT: 51,
  CHARAMOUNT: 126,
  DELETE_CHAR_OK: 5,
  SERVERVERSION: 151,
  CHARLIST: 184,
  MOVEOBJECT: 122,
  INITPACKET: 161,
} as const;

// Chat types for C_OPCODE_CHAT (opcode 190 in 3.63C).
export const CHAT_TYPE = {
  NORMAL: 0,
  SHOUT: 2,
  WORLD: 3,
  CLAN: 4,
  PARTY: 11,
  TRADE: 12,
  ALLIANCE: 13,
} as const;

// Login result codes from S_OPCODE_LOGINRESULT (opcode 51 in 3.63C).
export const LOGIN_RESULT = {
  OK: 0,
  EXISTS: 7,
  WRONG_PASSWORD: 8,
  IN_USE: 22,
} as const;

export type COpcode = typeof C_OPCODE[keyof typeof C_OPCODE];
export type SOpcode = typeof S_OPCODE[keyof typeof S_OPCODE];
export type ChatType = typeof CHAT_TYPE[keyof typeof CHAT_TYPE];